import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';
import { UpdateFormSubmissionDto } from './types';

/**
 * Update an existing form submission
 */
export async function updateFormSubmission(
  submissionId: string,
  data: UpdateFormSubmissionDto,
  shareToken: string | undefined
): Promise<{ success: boolean }> {
  try {
    const res = await fetcher(`${BASE_URL}/${submissionId}`, {
      method: 'POST',
      body: data,
      shareToken,
    });

    if (!res.ok) {
      console.error('Failed to update form submission:', await res.text());
      return { success: false };
    }

    return { success: true };
  } catch (err) {
    console.error('Error updating form submission:', err);
    return { success: false };
  }
}

